import React from 'react';
import styled from 'styled-components/macro';

const highlightColor = '#d2efff';

const Highlight = styled.mark`
  background-color: ${highlightColor};
`;


const resolveAttribute = (obj, key) => key
  .split('.')
  .reduce((prev, curr) => prev?.[curr], obj);

const highlight = (value, indices = [], i = 1) => {
  const pair = indices[indices.length - i];
  return !pair ? value : (
    <>
      {highlight(value.substring(0, pair[0]), indices, i+1)}
      <Highlight>{value.substring(pair[0], pair[1]+1)}</Highlight>
      {value.substring(pair[1]+1)}
    </>
  );
};

const FuseHighlight = ({ hit, attribute }) => {
  const matches = typeof hit.item === 'string'
    ? hit.matches?.[0]
    : hit.matches?.find(m => m.key === attribute);
  const fallback = typeof hit.item === 'string'
    ? hit.item
    : resolveAttribute(hit.item, attribute);
  return highlight(matches?.value || fallback, matches?.indices);
};

export default FuseHighlight;
